<template>
	<nav>
		<ul class="panel-menu">
			<li v-for="(item,index) in menuItems" v-on:click="menuItemClick(item,index)" :class="{
				'active' : item == activeItem || typeof item == 'object' && ('link' in item && item.link == activeItem) || (typeof item == 'object' && 'text' in item && item.text == activeItem)
			}">

				<template v-if="typeof item == 'string'">
					{{item}}
				</template>
				<router-link v-else-if="'link' in item && directLink" :to="item.link">
					<i v-if="'icon' in item" class="fa" :class="item.icon"></i>
					{{item.text}}
				</router-link>
				<template v-else-if="'text' in item">
					<i v-if="'icon' in item" class="fa" :class="item.icon"></i>
					{{item.text}}
				</template>
				
			</li>
			<li v-if="newButton" v-on:click="$emit('newClick')">
				<i class="fa fa-plus"></i> {{ newButton }}
			</li>
		</ul>
	</nav>
</template>
<script type="text/javascript">

export default {
	name: "PanelMenu",
	props: [
		"menuItems", //array of {text: string, link: string, icon: string} or just regular string array
		"activeItem", //link or text of active item
		"newButton",
		"directLink"
	],
	methods: {
		menuItemClick(item,index) {
			this.$emit("itemClick",item,index)
		}
	}
}
</script>

<style type="text/css" scoped>
	ul {
		display: flex;
		flex-direction: column;
		list-style: none;
		padding: 0;
		margin: 0;
		margin: -10px;
		color: #757575
	}

	li:first-of-type {

	}

	li {
		padding: 12px;
	}

	li:hover {
		background-color: #b1b5b766;
		cursor: pointer;
	}

	li.active {
		background-color: #fdfdfd;
		border-right: 3px solid var(--brand-primary-color);
	}
</style>